import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC } from 'react';

import ConfirmButton from 'primitives/ConfirmButton';

const REMOVE_SHARE_VALUATION_CHANGE_MUTATION = gql(`
  mutation RemoveShareValuationChange($id: ID!) {
    removeShareValuationChange(compositeId: $id) {
      id
      company {
        id
      }
    }
  }
`);

const RemoveShareValuationChangeButton: FC<{ id: string; onRemove: () => void }> = ({
  id,
  onRemove,
}) => {
  const [removeShareValuationChange, { loading, error }] = useMutation(
    REMOVE_SHARE_VALUATION_CHANGE_MUTATION,
    {
      update(cache, { data }) {
        if (!data) return;
        cache.modify({
          id: cache.identify({
            id: data.removeShareValuationChange.company.id,
            __typename: 'CompanyType',
          }),
          fields: {
            shareValuationChanges(existingShareValuationChangesRef, { readField }) {
              return existingShareValuationChangesRef.filter(
                shareValuationChangeRef => id !== readField('id', shareValuationChangeRef)
              );
            },
          },
        });
      },
      onCompleted() {
        onRemove();
      },
      refetchQueries: ['fetchAssetsByCompanyId'],
    }
  );

  return (
    <ConfirmButton
      onConfirm={() => removeShareValuationChange({ variables: { id } })}
      loading={loading}
      error={error}
      description="This will delete all data concerning this Share Valuation Change."
    >
      Remove Share Valuation Change
    </ConfirmButton>
  );
};

export default RemoveShareValuationChangeButton;
